export default {
  mainRecommandations: {
    tutorialTitle: "Let’s learn how to play with Tokatab!",
    continue: '➡️ Resume exercise',
    discover: 'Discover Tokatab',
    continueCourse: 'Continue Course',
    startLearningNewPiece: 'Start Learning a New Song',
    continueModule: 'Continue Module',
    reviewConcept: 'Review Concept',
    startNewModule: 'Start New Module',
    discoverTokatab: 'Discover Tokatab',
    finishedAllSkills: 'Congratulations for completing all the skills in your learning path!',
    goToNextLevel: 'Go to next level',
    alreadyMaxLevel: 'You are already at the highest level!'
  },
  catalogEntry: {
    challenge: 'Challenge',
    piece: 'Piece',
  },
  userRevisionPage: {
    title: 'To Review',
    contentToRevise: 'You have {count} content{plural} to review',
    contentToReviseDesktop: 'You have {count} content{plural} that you can review',
    emptyMessage: 'You have already reviewed everything!'
  },
  userCatalogPage: {
    title: 'My History',
    inProgress: 'In Progress',
    completed: 'Completed',
    noInProgressMessage: 'No songs in progress',
    noCompletedMessage: 'You haven\'t learned any songs completely yet.'
  },
  importMusicxmlPiecePage: {
    title: 'Add a Song',
    errorPersist: 'If the error persists please',
    contactSupport: 'contact support.',
    selectFile: 'Click here to select a sheet music file in MusicXML format',
    loadingFile: 'Loading file...',
    acceptedFormats: 'Accepted formats: .xml, .musicxml.',
    whatIsMusicxml: 'What is MusicXML? Where can I find sheet music in this format?',
    titleLabel: 'Title',
    artistLabel: 'Artist',
    musicStyleLabel: 'Music Style (Optional)',
    coverImageLabel: 'Cover Image (optional)',
    importButton: 'Import Song',
    importLoading: 'Importing may take a few minutes...',
    importSuccess: 'Song imported successfully!',
    unknownError: 'An unknown error occurred while importing the song.'
  },
  importMusicxmlErrors: {
    UNHANDLED_EXCEPTION: 'An unhandled exception occurred.',
    ISSUE_IN_MUSICXML_FILE: 'The MusicXML file contains errors.',
    MULTI_VOICE_NOT_SUPPORTED: 'Multi-voice scores are not supported.',
    TUPLETS_NOT_SUPPORTED: 'Triplet notes or other complex rhythms are not supported.',
    MISSING_FINGERING: 'Some notes are missing fingering.',
    FILE_NOT_FOUND: 'The MusicXML file cannot be found.',
    NO_TIME_SIGNATURE: 'The score must contain a time signature (e.g., 4/4, 3/4, etc.).',
    NO_HANDPRINT_FOUND: 'No hand shape generated in the score.',
    NOTE_NOT_IN_HANDPRINT: 'Some notes are not in the hand shape.',
    PIECE_ALREADY_EXISTS: 'This score already exists in your library.',
    INVALID_FILE_TYPE: 'The file type is not valid. Please use a .xml or .musicxml file.',
    handLabel: 'Hand:',
    measureLabel: 'Measure:',
    divisionLabel: 'Division:'
  },
  importMusicxmlSteps: {
    labels: {
      PENDING: 'Pending',
      STARTED: 'Started',
      FINGERING_FILLING: 'Filling Fingering',
      MUSICXML_PARSING: 'Analyse MusicXML',
      HANDPRINT_PARSING: "Analyse Hand Shapes",
      RHYTHMIC_PARSING: 'Analyse Rhythmics',
      TIMELINE_GENERATION: 'Generate Timeline',
      COMPLETED: 'Completed',
      FAILED: 'Failed',
    },
    descriptions: {
      PENDING: 'Your song is in the queue for import, it will start soon.',
      STARTED: 'The import process has started.',
      FINGERING_FILLING: "We'll fill in the missing fingerings in your sheet music.",
      MUSICXML_PARSING: 'We analyze the MusicXML file to extract the musical information.',
      HANDPRINT_PARSING: "We analyze the fingerprint to match the notes to the hand positions.",
      RHYTHMIC_PARSING: 'We are analyzing the tempo of the sheet music.',
      TIMELINE_GENERATION: 'We generate the timeline for playing the track. This step may take some time',
      COMPLETED: 'Your import was successful!',
      FAILED: 'An error occurred while importing your sheet music.'
    }
  },
  homePage: {
    logoAlt: 'Tokatab Logo',
    yourProgress: 'Your Progress',
    discoveryPath: 'Discovery Path',
    missions: '{completed} / {total} missions',
    coursePath: '{levelName} Level',
    completedAt: 'Completed at {percentage}',
    teacherRecommendations: 'Prof Tokatab\'s Recommendations',
    welcomeMessageCongratsPieces: 'Congratulations on {text}! Here’s what I suggest next',
    welcomeMessageCongratsModules: 'Congratulations on {text}! Here’s what I suggest next',
    welcomeMessageCongratsSkills: 'Congratulations on {text}! Here’s what I suggest next',
    welcomeMessageCongratsChallenges: 'Congratulations on {text}! Here’s what I suggest next',
    welcomeMessageCongratsExercises: 'Congratulations on {text}! Here’s what I suggest next',
    welcomeMessageDefault: 'Hello {firstName}! Here\'s what you can work on today:',
    welcomeMessageReturn: 'Hello {firstName}! Great to see you again! Here\'s what I suggest you do:',
    welcomeMessageGreatSession: 'Hello {firstName}! Let\'s have a great session today! Here\'s what I suggest:',
    welcomeMessageContinue: 'Here’s what I suggest next',
    progressRecommendations: 'Here are my recommendations to progress',
    priorityContentToRevise: 'Here are the priority contents among the {count} to review ({seeAllLink})',
    seeAll: 'See All',
    applySkillsText: 'To apply your skills in songs or challenges',
    revisions: 'Reviews',
    seeMore: 'See More',
    history: 'History',
    piecesValidated: 'the validated songs',
    pieceValidated: 'the validated song',
    modulesValidated: 'the validated modules',
    moduleValidated: 'the validated module',
    skillsValidated: 'the validated skills',
    skillValidated: 'the validated skill',
    challengesValidated: 'the validated challenges',
    challengeValidated: 'the validated challenge',
    exercisesValidated: 'the validated exercises',
    exerciseValidated: 'the validated exercise',
    loadingMessage: 'I\'m preparing your personalized recommendations...'
  },
  catalogPage: {
    searchPlaceholder: 'Search by title or artist',
    sortBy: 'Sort by {sortType}',
    filters: 'Filters',
    filtersWithCount: 'Filters ({count})',
    validate: 'Validate',
    recommendations: 'Recommendations',
    pieces: 'Songs',
    noResults: 'No results',
    resetFilters: 'Reset Filters',
    addPiece: 'Add a Song',
    sortTypeDefault: 'Mastery',
  },
  challengesPage: {
    title: 'Challenges',
    searchPlaceholder: 'Search by title or artist',
    recommendations: 'Recommendations',
    difficultyNovice: 'Novice',
    difficultyBeginner: 'Beginner',
    difficultyIntermediate: 'Intermediate',
    difficultyAll: 'All',
    completedChallenges: 'You have completed <span class="text-blue-7 text-weight-bold">{count}</span> challenge(s) in this difficulty'
  },
  otherSuggestionsModal: {
    title: 'Other Suggestions',
    tabRevisions: 'Reviews',
    tabModules: 'Modules',
    tabPieces: 'Songs',
    tabChallenges: 'Challenges',
    emptyRevisions: 'I don\'t have any reviews to recommend at the moment.',
    emptyModules: 'You have completed all modules at your level, you can move to the next level!',
    emptyPieces: 'I don\'t have any songs to recommend at the moment, but you can explore the repertoire.',
    emptyChallenges: 'I don\'t have any challenges to recommend at the moment, but you can explore challenges by clicking the button below.',
    seeMore: 'See More',
    seeOtherLessons: 'See Other Lessons',
    explorePieces: 'Explore Songs',
    exploreChallenges: 'Explore Challenges'
  },
  courseLevelSelector: {
    title: 'View Courses',
    evaluationBannerText: 'Let\'s check your level with some challenges.',
    evaluationBannerButton: 'Take the Test',
    evaluationBannerSkip: 'No thanks',
    activeCourse: 'Active Course',
    otherCourses: 'Other courses',
    higherLevels: 'Higher levels',
    lowerLevels: 'Lower levels',
    warningMessage: 'I do not recommend starting this course, you might have difficulties and develop bad reflexes.',
    skillsValidated: 'Skills from the current course will be automatically validated.',
    notRecommended: 'We do not recommend starting this course',
    riskDifficulties: 'you might have difficulties and develop bad reflexes.',
    skillsInvalidated: 'Skills from the new course will be invalidated and updated according to your current profile progress.',
    changeCourse: 'Change Course',
    cancel: 'Cancel',
    evaluationNotification: 'You can find the test anytime in your profile.',
    loading: 'This operation may take a few moments, please wait.',
    alreadyMaxLevel: 'You are already at the highest level!'
  },
  homeWelcomeModal: {
    continue: 'Continue',
    newPiecesMultiple: '{count} new songs arranged by our team are now available!',
    newPieceSingle: 'A new song arranged by our team is now available!'
  },
  toPlayTodayModal: {
    launchButton: 'I don\'t know what to play!',
    greeting: 'Hi {firstName}!',
    timeQuestion: 'How much time do you want to dedicate to Tokatab for this session?',
    shortTime: 'I have little time',
    shortTimeSubtitle: '(~ 15 minutes)',
    mediumTime: 'I have some time',
    mediumTimeSubtitle: '(~ 30 minutes)',
    longTime: 'I have plenty of time',
    longTimeSubtitle: '(more than 30 minutes)',
    regularityTip: 'To progress on piano, regularity is important; it\'s better to have several short sessions each week than one 3-hour session each month.',
    about15Minutes: 'About 15 minutes',
    continueProgress: 'Why not continue advancing on the educational course?',
    progressDescription: 'It will only take a few minutes and will help you progress while having fun!',
    resumeCourses: 'Resume Courses',
    nextExercise: 'Next Exercise',
    about30Minutes: 'About 30 minutes',
    challengesStarted: 'You started these challenges but never finished them',
    challengesRecommended: 'Here\'s a selection of challenges just for you!',
    challengesDescription: 'Finishing them will help you increase your mastery scores across the entire repertoire!',
    moreThan30Minutes: 'More than 30 minutes',
    piecesStarted: 'Let\'s continue learning this/these song(s)!',
    piecesRecommended: 'Here\'s a selection of songs that should be at your level!',
    piecesDescription: 'If you practice regularly you\'ll soon be able to play like a pro!',
    close: 'close'
  },
  newVersionRecommendations: {
    continue: 'Continue',
    congratulationsSingle: 'Congratulations. This song is now within your reach!',
    congratulationsMultiple: 'Congratulations. These songs are now within your reach!'
  },
  homePieceCourses: {
    piecesInProgress: '{count} songs in progress',
    completedAt: 'Completed at {percentage}%',
    removeFromProgress: 'Remove from songs in progress',
    continueCourse: 'Continue Course',
    removedMessage: 'I removed {title} from your songs in progress, it will be automatically added as soon as you resume the course progression.',
    loading: 'Loading...'
  },
  homeOnboardingChecklist: {
    title: 'Discovery Path',
    freeDaysToUnlock: '{days} day of trial period to unlock',
    freeDaysToUnlockPlural: '{days} days of trial period to unlock'
  },
  buySongModal: {
    title: 'Add this music to your catalog',
    description: 'Learn to play this song right now by adding it to your collection!',
    notYetAvailableMessage: 'Thank you for your interest! We don\'t allow purchases yet but we\'ve noted your intention and will get back to you very soon.'
  },
  homeSuggestionCard: {
    discoverSkill: 'Start Skill',
    validateSkill: 'Validate Skill',
    continueWorking: 'Continue skill',
    rework: 'Rework',
    review: 'Review',
    playChallenge: 'Play Challenge'
  },
  homeContent: {
    seeMore: 'See More',
    reviewAConcept: 'Review a Concept',
    lessons: 'Lessons',
    exercisesPlaceholder: 'You will find exercises to review here when I think you need them.',
    recommendations: 'Recommendations',
    toProgress: 'To Progress',
    easyToPlay: 'Easy to Play',
    news: 'News',
    filters: 'Filters',
    recentlyPlayed: 'Recently Played',
    teacherSuggestion: 'Teacher\'s Suggestion',
    improvingRecommendations: 'We are working to improve recommendations, songs and challenges will appear here soon!',
    exploreInMeantime: 'In the meantime you can explore the',
    challenges: 'challenges',
    or: 'or the',
    repertoire: 'repertoire',
    findPieceToPlay: 'to find a song to play!',
    improveRecommendationsMessage: 'To improve your recommendations, you need to work on a few more songs!'
  },
  courseLevelCard: {
    skillGroupsCount: '{count} skill categories:',
    modulesToValidateCount: '{count} modules to validate:',
    skills: 'See details',
    lessons: 'Lessons',
    select: 'Select',
    seePath: 'See Path',
    levelName: 'Level {name}'
  },
  schoolItem: {
    rework: 'rework',
    review: 'review',
    modules: 'Modules',
    premium: 'Premium',
    toRework: 'To Rework',
    toReview: 'To Review'
  },
  homeModuleCard: {
    title: 'Tokatab Lessons',
    description: 'Educational modules, for all levels, that will help you acquire or strengthen piano techniques.',
    viewLessons: 'View Lessons'
  },
  catalogItem: {
    accompanimentPiano: '(Accompaniment Piano)',
    toRework: '- To Rework',
    toReview: '- To Review',
    premium: 'Premium'
  },
  catalogEntryPopup: {
    notInterested: 'This song doesn\'t interest me',
    info: 'Info',
    play: 'Play',
    bothHands: 'both hands',
    rightHand: 'right hand',
    leftHand: 'left hand',
    masteredPiece: 'Congratulations! You have mastered this song. Don\'t hesitate to play it from time to time so you don\'t forget it!',
    addToPieceCourses: 'Add to Songs in Progress'
  },
  catalogMiniature: {
    accompanimentPiano: 'Accompaniment Piano'
  },
  difficultyIndicator: {
    generic: 'Generic',
    novice: 'Novice',
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    pro: 'Pro'
  }
};